import { useSelectionContext, useSelectionCount } from 'common/contexts/SelectionContext';
import * as React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { LoadingButton } from '@mui/lab';
import pluralize from 'pluralize';

interface Props {
  open: boolean;
  onClose: () => void;
  onClick: () => void;
  isLoading: boolean;
}

export const DeleteConfirmationDialog: React.FC<Props> = (props) => {
  const { open, onClose, onClick, isLoading } = props;
  const { selection } = useSelectionContext();
  const count = useSelectionCount(selection);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogTitle className="flex justify-between py-2 items-center border-b border-gray-200">
        Delete Containers
        <IconButton className="rounded-full" color="info" onClick={onClose}>
          <XMarkIcon className="h-5 w-5 text-gray-900" />
        </IconButton>
      </DialogTitle>
      <DialogContent className="py-8">
        <div className="text-base">
          Are you sure that you want to delete {count} {pluralize('container', count)}? Deleted
          containers will be removed from your watchlist and your per diem and demurrage reports.
        </div>
      </DialogContent>
      <DialogActions className="border-t border-gray-200 justify-between">
        <LoadingButton
          variant="contained"
          color="error"
          onClick={onClick}
          className="mx-5 my-1 bg-surface-interactive-accent-5 hover:bg-red-600"
          loading={isLoading}
        >
          Delete
        </LoadingButton>
        <Button variant="contained" color="inherit" onClick={onClose} className="mx-5 my-1">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
DeleteConfirmationDialog.displayName =
  'Shipments.Containers.ActionBar.Delete.DeleteConfirmationDialog';
